export class Dealer {
  id: string;
  name: string;
}
